<template>
  <div class="sheet" v-if="item && item.ruleset">
    <div class="row" v-if="canEdit">
      <div class="col text-right action-bar">
        <strong class="subheader">
          <i
            v-show="inSync === null"
            class="fa fa-exclamation-triangle fa-fw"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Network Error"
          ></i>
          <i v-show="dirty && inSync !== null" class="fa fa-refresh fa-spin fa-fw"></i>
          <i v-show="!dirty" class="fa fa-check-circle text-success fa-fw"></i>
          |
          {{ item.ruleset }}
          <span>
            |
            <span v-if="!dirty" class="c5">
              <i class="fa fa-save fa-fw"></i>
            </span>
            <a v-else @click="patchData()">
              <i class="fa fa-save fa-fw"></i>
            </a>
            |
          </span>
        </strong>
        <strong class="c5">
          <a @click="$router.push({path: `/characters/${id}/edit`})">
            <i class="fa fa-gear fa-fw"></i>
          </a>
        </strong>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col text-right action-bar">
        <strong class="subheader">{{ item.ruleset }}</strong>
      </div>
    </div>
    <fifth-edition v-if="['5th Edition', '5e24'].includes(item.ruleset)" :item="item"></fifth-edition>
    <pfrpg v-if="item.ruleset === 'PFRPG'" :item="item"></pfrpg>
    <pfrpg2 v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(item.ruleset)" :item="item"></pfrpg2>
    <savage-worlds  v-if="['Savage Embers', 'Savage Worlds'].includes(item.ruleset)" :item="item"></savage-worlds>
    <solarian-conflict v-if="item.ruleset === 'Solarian Conflict'" :item="item"></solarian-conflict>
  </div>
</template>

<script>
import Detail from "@/components/character/_Detail";
import FifthEdition from "./sheet/_5thEdition.vue";
import Pfrpg from "./sheet/_Pfrpg.vue";
import Pfrpg2 from "./sheet/_Pfrpg2.vue";
import SavageWorlds from "./sheet/_SavageWorlds.vue";
import SolarianConflict from "./sheet/_SolarianConflict.vue";
import UnderInput from "./sheet/shared/_UnderInput.vue";
import UnderText from "./sheet/shared/_UnderText.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "character-sheet",
  components: {
    Detail,
    FifthEdition,
    Pfrpg,
    Pfrpg2,
    SavageWorlds,
    SolarianConflict,
    UnderInput,
    UnderText,
  },
  props: ["id"],
  data() {
    return {
      showViewModal: false,
    };
  },
  watch: {
    $route: "getData",
    inSync: "patchData",
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      canEdit: "characters/canEdit",
    }),
    ...mapState({
      user: (state) => state.session.user,
      item: (state) => state.characters.current,
      dirty: (state) => state.characters.dirty,
      inSync: (state) => state.characters.inSync,
    }),
  },
  methods: {
    ...mapActions({
      charactersEdit: "characters/edit",
      charactersUpdate: "characters/update",
      charactersClone: "characters/clone",
      charactersDestroy: "characters/destroy",
      setInSync: "characters/setInSync",
      setDirty: "characters/setDirty",
      setUpdatedAt: "characters/setUpdatedAt",
    }),
    async getData() {
      try {
        await this.charactersEdit({ id: this.id });
        this.$embers.pageData(this.item.name, this.item.description);
      } catch (err) {
        console.error(err);
      }
    },
    async patchData() {
      if (this.inSync === false) {
        this.setDirty(true);
        try {
          let u = await this.$http.patch(`/characters/${this.id}`, this.item);
          let updatedAt = u.data.updatedAt || this.item.updatedAt;
          this.setUpdatedAt(updatedAt);
          this.setInSync(true);
        } catch (err) {
          this.setInSync(null);
          /* eslint-disable no-undef */
          $('[data-toggle="tooltip"]').tooltip();
          if (err.response.data) {
            let message = err.response.data.reason
              ? `${err.response.data.reason.message} under path ${err.response.data.path}`
              : err.response.data.message;

            this.$toastr.error(message, "Ooops!");
          } else {
            this.$toastr.error("Something Went Wrong..", "Ooops!");
          }
        }
      }
    },
    async cloneData() {
      try {
        let clone = await this.charactersClone(this.item);
        this.$router.push({ path: `/characters/${clone._id}/sheet` });
      } catch (err) {
        this.setInSync(null);
        /* eslint-disable no-undef */
        $('[data-toggle="tooltip"]').tooltip();
        console.error(err);
      }
    },
    async deleteData() {
      try {
        await this.charactersDestroy();
        this.$router.push({ path: `/characters` });
      } catch (err) {
        this.setInSync(null);
        /* eslint-disable no-undef */
        $('[data-toggle="tooltip"]').tooltip();
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/_global";

.sheet {
  margin-top: -1rem;

  label {
    font-weight: bold;
    font-size: 0.875rem;
  }

  section {
    .content {
      margin: 0.25em;
    }
  }

  .header-bar {
    font-size: 1rem;
    margin: 0.25em 0;
    text-align: right;
  }

  .row {
    margin-right: -0.25rem;
    margin-left: -0.25rem;

    > .col,
    > [class*="col-"] {
      padding-right: 0.25rem;
      padding-left: 0.25rem;
    }
  }

  .tight {
    margin-right: -0.1rem;
    margin-left: -0.1rem;

    > .col,
    > [class*="col-"] {
      padding-right: 0.1rem;
      padding-left: 0.1rem;
    }
  }

  .form-group {
    margin-bottom: 0;
  }

  .fa-exclamation-triangle {
    color: $danger;
  }

  .cogs125 {
    line-height: 1;
    font-size: 1.25em;
  }

  .item-description {
    font-size: 0.875em;
  }

  h6.rule {
    margin-bottom: 0;
    color: $gray-600;
  }

  .rule-indent {
    margin-left: 0.5em;
  }
}
</style>
